import { ResearchSummary } from '../types/bom.types';
import { StageReport, failedStage } from '../utils/stageActivity';
import { analysisCopy, validationCopy } from '../utils/waitCopy';
import { useDiscoveryResearchReport } from './useDiscoveryResearchReport';
import { useReportStageActivity } from './useStageActivity';

interface BomStageInput {
  subStep: number;
  analysisRunning: boolean;
  analysisFailed: boolean;
  analysisComponents: number;
  validationRunning: boolean;
  validationFailed: boolean;
  startingResearch: boolean;
  research: ResearchSummary | null;
  components: object[];
}

/**
 * What step 3 tells Robbie's panel, in the overlay's own words: the blocking
 * analysis (the context sub-step stays answerable, so it is excluded there),
 * the validation check, a failed run of either, the research kickoff, and
 * while research runs on discovery the live count instead of a suggestion.
 */
export const reportOf = (i: BomStageInput, researchReport: StageReport | null): StageReport | null => {
  if (i.analysisRunning && i.subStep !== 1) return { stage: 'bom-analysis', text: analysisCopy.panel(i.analysisComponents) };
  if (i.analysisFailed) return failedStage('bom-analysis', analysisCopy.failedTitle);
  if (i.subStep === 2 && i.validationRunning) return { stage: 'bom-validation', text: validationCopy.panel(i.components.length) };
  if (i.subStep === 2 && i.validationFailed) return failedStage('bom-validation', validationCopy.failedTitle);
  if (i.startingResearch) return 'research-start';
  return researchReport;
};

export const useBomStageReport = (onWorking: ((s: StageReport | null) => void) | undefined, input: BomStageInput) => {
  const researchReport = useDiscoveryResearchReport(input.subStep === 3, input.research, input.components);
  useReportStageActivity(onWorking, reportOf(input, researchReport));
};

export default useBomStageReport;
